import { createStoreFinancialInput } from "src/components/FinancialInput";
import { ZAttribute } from "src/types/ZAttribute";
import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zAttrFinancialInput = z.object({
  editor: z.literal("FinancialInput"),
  labelAttr: zUid,
});
export type ZAttrFinancialInput = z.infer<typeof zAttrFinancialInput>;
export const makeFinancialInputProps = (attribute: ZAttribute) => ({
  store: createStoreFinancialInput(attribute),
});
